import { useEffect, useState } from 'react';

export const PHONE_MEDIA_QUERY = '(max-width: 768px)';

const getMediaQueryList = (query) => (
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(query)
        : null
);

/** Tracks a media query and re-renders when it flips, e.g. on window resize or rotation. */
const useMatchMedia = (query) => {
    const [matches, setMatches] = useState(() => Boolean(getMediaQueryList(query)?.matches));

    useEffect(() => {
        const mediaQueryList = getMediaQueryList(query);
        if (!mediaQueryList) return undefined;

        const handleChange = () => setMatches(mediaQueryList.matches);
        handleChange();

        // Safari < 14 only implements the deprecated addListener API.
        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener('change', handleChange);
            return () => mediaQueryList.removeEventListener('change', handleChange);
        }
        mediaQueryList.addListener(handleChange);
        return () => mediaQueryList.removeListener(handleChange);
    }, [query]);

    return matches;
};

export default useMatchMedia;
